// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"dec6c7e2","230":"f4fe9427","490":"c181d7cb","708":"64ab41fe","787":"55493f23","856":"98b3347a"}[chunkId] + ".chunk.js";
};